// 兼容IE
// import "Babel-polyfill"

import ElementUI from "element-ui"
import 'element-ui/lib/theme-chalk/index.css'
import '../static/icon/iconfont.css'
import SIdentify from './views/sIdentity/sIdentity'
import VueContextMenu from 'vue-contextmenu'
import Qs from 'qs'
import * as XLSX from "xlsx";
import axios from 'axios'
import store from './store'
import Print from 'vue-print-nb'
import downloadUtil from './components/downloads/download'
import timeUtil from './components/dateFormats/format'
import Vue from 'vue'
import App from './App'
import router from './router/router'
import mixin from '@/mixin'
import Theme from "./components/theme.vue";
import { theme } from "./components/theme/theme.js"
import loadingUtil from "./components/loading/loading"
// var docx = require("docx-preview");
// export {default as TagsView} from './components/TabsView'
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.component('s-identify', SIdentify)
Vue.use(VueContextMenu)
Vue.use(XLSX)
Vue.use(Print)
Vue.mixin(mixin)
Vue.component("en-theme", Theme)
Vue.directive("theme", theme)
// Vue.use(docx)
// Vue.use(downloadFile)
Vue.prototype.$qs = Qs
Vue.prototype.$axios = axios
Vue.prototype.downloadUtil=downloadUtil
Vue.prototype.loadingUtil=loadingUtil
Vue.prototype.timeUtil=timeUtil
// Vue.use(timeUtil)
// Vue.http.options.emulateJSON = true;

// 导航守卫已在 router/router.js 中统一配置
new Vue({
  el: '#app',
  router,
  data (){
    return {
      badgeValue:0
    };
  },
  store,
  components: { App },
  template: '<App/>'
})

Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 2000)
      }
    })
  }
});


// WEBPACK FOOTER //
// ./src/main.js